import type { FaireProductEntity } from "../../entity_types/product";

export const p_4sgyrxzevs: FaireProductEntity = {
  token: "p_4sgyrxzevs",
  type: "product",
  name: "Pansy Cardigan Rosy for Baby & Toddler",
  brandToken: "b_e6gi5qy7n8",
  brandName: "Huggalugs",
  imageUrl:
    "https://cdn.faire.com/fastly/4c7860480b92c447919409c5d463b01a78a600e87ddd50ada2ca088ceebcf553.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7f4d13bb51427d12ec4e561f29ed655acc831ca37db2c8749daf45516b5a2ffa.png",
    "https://cdn.faire.com/fastly/6b59e7d033f9691d3a583d709c3a7c9d64234426e2023dbf1bfcd9f67115a6b4.png",
  ],
  priceDollars: 26,
  description:
    "This rosy pink cardigan takes on an elevated, artisan charm with its delicately crocheted pansies, each one adding a touch of handcrafted beauty. Hand knit from soft, cozy yarn, the sweater is finished with natural wood buttons that lend a warm, timeless feel. Pair it with the coordinating Pansy Beanie to create a refined, heirloom‑worthy look.\n\nOur sweaters are crafted using recycled, sustainable polyester yarn spun from reclaimed plastic bottles, a thoughtful choice that helps lessen global plastic waste. It’s one small way we’re contributing to a cleaner, more sustainable world. ♻️\n\n• Hand Knit\n• 60% Acrylic, 40% Recycled Polyester\n• Hand Wash\n• Designed in our Coachella Valley, CA studio\n",
  tags: [],
  msrpDollars: 52,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:12.221Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
